import Urls from "../../api/endpoints";
import Draggable from "react-draggable";
import Headings from "../../constants/headings";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom"
import { useMousePosition } from "../../functions/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
function UserBar(props) {
  const [show, setShow] = useState(false);
  const location = useLocation()
  const [customer, setCustomer] = useState(null);
  const { x, y } = useMousePosition();
  const setLocation = () => {
    props.setAxisY(y);
    if (!window.innerWidth < x) props.setAxisX(x);
  };
  useEffect(() => {
   if(location.pathname==='/promotions'|| location.pathname==='/lines-list'  ){
        setShow(false)
        setCustomer(null)
   }
  }, [location])

  useEffect(() => {
    fetch(Urls.getSearchedUserById(props.userId), {
      method: "Get",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + props.token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setCustomer(data);
        setShow(true);
      })
      .catch((error) => {
        console.log(`--userBar error: ${error}`);
      });
  }, [props.userId, props.token]);
  return (
    <Draggable
      defaultPosition={{
        x:
          props.axisX === 20
            ? -props.axisX
            : props.axisX + 200 - window.innerWidth,
        y: props.axisY === 5 ? props.axisY : props.axisY - 80,
      }}
      onStop={setLocation}
    >
      <div className={show ? "userBar" : "userBar roll-up"}>
        {show && customer && (
          <>
            <small>{Headings.YouAreWatching}: </small>
            <b>
              {customer.FirstName} {customer.LastName}
            </b>
          </>
        )}

        {show && customer && <span className="close" onClick={() => setShow(!show)}>
          {show ? (
            <FontAwesomeIcon icon={faChevronUp} />
          ) : (
            <FontAwesomeIcon icon={faChevronDown} />
          )}
        </span>}
      </div>
    </Draggable>
  );
}
export default UserBar;
